module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_home1.b19fe.png";